
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/m/event",
      function () {
        return require("private-next-pages/m/event/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/m/event"])
      });
    }
  